"use client";

import { useQueryClient } from "@tanstack/react-query";
import { AppNames } from "@watt/common/libs/supabase/cookie-config";
import { queryKeysFactory } from "@watt/common/utils/query-keys-factory";
import AutoForm, {
  AutoFormButton
} from "@watt/ui/components/ui/auto-form/auto-form";
import { useRouter } from "next/navigation";
import { useAction } from "next-safe-action/hooks";
import { useEffect } from "react";
import { toast } from "sonner";
import { signIn } from "../../action";
import { UserAuthSchema } from "../../schema";
import { TurnstileAutoFormField } from "./turnstile-auto-form-field";

export function UserLoginForm() {
  const router = useRouter();
  const queryClient = useQueryClient();

  const formAction = useAction(signIn, {
    onError: ({ error }) => {
      toast.error("Sign-in failed", {
        description:
          error.validationErrors?._errors?.[0] ??
          "An error occurred during sign-in."
      });
    },
    onSuccess: result => {
      if (result?.data?.success && result?.data?.redirectTo) {
        queryClient.invalidateQueries({
          queryKey: queryKeysFactory.users.supabaseUser(AppNames.CRM)
        });
        // Use router.push for client-side navigation to ensure proper GET request
        router.replace(result.data.redirectTo);
      }
    }
  });

  useEffect(() => {
    if (
      Notification.permission !== "granted" &&
      Notification.permission !== "denied"
    ) {
      Notification.requestPermission().then(permission => {
        if (permission === "granted") {
          console.info("Notification permission granted.");
        }
      });
    }
  }, []);

  return (
    <AutoForm
      fieldConfig={{
        email: {
          inputProps: {
            autoCapitalize: "none",
            autoComplete: "email",
            autoCorrect: "off",
            placeholder: "you@watt.com"
          }
        },
        password: {
          inputProps: {
            autoCapitalize: "none",
            autoComplete: "current-password",
            autoCorrect: "off",
            placeholder: "••••••••",
            type: "password"
          }
        },
        turnstileToken: {
          fieldType: TurnstileAutoFormField,
          inputProps: {
            showLabel: false
          },
          label: "Security check"
        }
      }}
      formAction={formAction}
      formSchema={UserAuthSchema}
    >
      {({ isSubmitting }) => (
        <AutoFormButton
          className="w-full"
          disabled={isSubmitting}
          isSubmitting={isSubmitting}
        >
          Login
        </AutoFormButton>
      )}
    </AutoForm>
  );
}
